// 23	Enel X
// 33	CarCharging
// 40	EV Point, Move Eletromobilidade
// 71	Webasto
// 1045	Charge+
// 1049	Base2Charge
// 1082	YASNO E-mobility
// 1084	Evolt
// 1105	Porsche Destination Charging
// 1222	Move Eletromobilidade
// 1223	Sollus Indústria Eletrônica LTDA
// 1224	Easy Volt Brasil
// 1243	Copec Voltex
// 1264	EVBox B.V.
// 1272	WeCharge
// 1273	Zletric
// 1304	Copel
// 1337	Enel X Way
// 1377	ChargeZone
// 1383	ECODOT
// 1406	Vertys
// 1414	GOEC
// 1424	beepbeep
// 1442	OnCharge
// 1457	WA EV Network
// 1465	Plug&Go
// 1562	SAVE
// 1617	Power2Go
// 1637	Autocharge
// 1651	WEMOB
// 1665	Intelbras
// 1718	Tupinambá
// 1734	BR Super Carga
// 1742	Shell Recharge
// 1773	DCC ENERGY
// 1775	Neoenergia

export function getMajorityNetworkName(networkId: number): string {
  switch (networkId) {
    case 23:
      return "Enel X";
    case 33:
      return "CarCharging";
    case 40:
      return "EV Point, Move Eletromobilidade";
    case 71:
      return "Webasto";
    case 1045:
      return "Charge+";
    case 1049:
      return "Base2Charge";
    case 1082:
      return "YASNO E-mobility";
    case 1084:
      return "Evolt";
    case 1105:
      return "Porsche Destination Charging";
    case 1222:
      return "Move Eletromobilidade";
    case 1223:
      return "Sollus Indústria Eletrônica";
    case 1224:
      return "Easy Volt Brasil";
    case 1243:
      return "Copec Voltex";
    case 1264:
      return "EVBox B.V.";
    case 1272:
      return "WeCharge";
    case 1273:
      return "Zletric";
    case 1304:
      return "Copel";
    case 1337:
      return "Enel X Way";
    case 1377:
      return "ChargeZone";
    case 1383:
      return "ECODOT";
    case 1406:
      return "Vertys";
    case 1414:
      return "GOEC";
    case 1424:
      return "beepbeep";
    case 1442:
      return "OnCharge";
    case 1457:
      return "WA EV Network";
    case 1465:
      return "Plug&Go";
    case 1562:
      return "SAVE";
    case 1617:
      return "Power2Go";
    case 1637:
      return "Autocharge";
    case 1651:
      return "WEMOB";
    case 1665:
      return "Intelbras";
    case 1718:
      return "Tupinambá";
    case 1734:
      return "BR Super Carga";
    case 1742:
      return "Shell Recharge";
    case 1773:
      return "DCC ENERGY";
    case 1775:
      return "Neoenergia";
    default:
      return "Unknown";
  }
}
